import { TripHelper } from '@lib/TripHelper'
import { countLabel } from '@/utils/plural'
import { Trip } from '@types'
import React from 'react'
import {
	EventInfo,
	TripStrip,
	TripStripDates,
	TripStripIcon,
	TripStripLabel,
	TripStripName,
} from '../ItineraryImportPage.styles'
import { TripSummary } from '../types'
import { PlanetGlyph } from './icons'

interface TripContextStripProps {
	trip: TripSummary
}

const TripContextStrip: React.FC<TripContextStripProps> = ({ trip }) => {
	const tripHelper = trip.startDate ? new TripHelper(trip as unknown as Trip) : null
	const startStr = tripHelper?.getFormattedStartDate() ?? 'No dates'
	const endStr = tripHelper?.getFormattedEndDate() ?? ''
	const days = trip.dayCount ?? 0
	const dateRange = endStr ? `${startStr} — ${endStr}` : startStr
	return (
		<TripStrip>
			<TripStripIcon>
				<PlanetGlyph size={16} />
			</TripStripIcon>
			<EventInfo>
				<TripStripLabel>Importing into</TripStripLabel>
				<TripStripName>{trip.name}</TripStripName>
			</EventInfo>
			<TripStripDates>
				{days > 0 && (
					<span>
						{countLabel(days, 'day')}
					</span>
				)}
				<span>{dateRange}</span>
			</TripStripDates>
		</TripStrip>
	)
}

export default TripContextStrip
